/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const knownCustomerNumberWriteBodyNumberMax = 80;

export const knownCustomerNumberWriteBodyExpectedCustomerVersionExclusiveMin = 0;
export const knownCustomerNumberWriteBodyExpectedCustomerVersionMax = 9007199254740991;

export const KnownCustomerNumberWriteBody = zod.object({
  number: zod.string().min(1).max(knownCustomerNumberWriteBodyNumberMax),
  expectedCustomerVersion: zod
    .int()
    .gt(knownCustomerNumberWriteBodyExpectedCustomerVersionExclusiveMin)
    .max(knownCustomerNumberWriteBodyExpectedCustomerVersionMax),
});

export type KnownCustomerNumberWriteBody = zod.input<typeof KnownCustomerNumberWriteBody>;
export type KnownCustomerNumberWriteBodyOutput = zod.output<typeof KnownCustomerNumberWriteBody>;
